module.exports = __webpack_public_path__ + "img/MoMo_Logo.6e406ef3.png";